import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QuickPanelService {
  private _openSubject = new BehaviorSubject<boolean>(false);
  open$ = this._openSubject.asObservable();

  constructor() {}

  onSetOpen(val: boolean) {
    this._openSubject.next(val);
  }
}
